import { addToCollection } from "../addToCollection";
/**
 * @constant BffRequestBuilder - Helper constant containing methods for building requests to BFF
 */
export const BffRequestBuilder = {
    /**
     * Build BFF request
     * @param {BsUtilMsgItem[]} items Items, used to retrieve the request params
     * @return {EventsByEventIdForBetSlipRequest} Newly builded request
     */
    buildEventsByEventIdForBetSlipRequest(items) {
        let request = {
            ids: [],
            marketIds: [],
            selectionIds: []
        };
        items.forEach((curr) => {
            request.ids = addToCollection(request.ids, curr.eventId);
            request.marketIds = addToCollection(request.marketIds, curr.marketId);
            request.selectionIds = addToCollection(request.selectionIds, curr.selectionId);
        });
        return request;
    }
};
//# sourceMappingURL=bffRequestBuilder.js.map